import {
  ElementRef,
  EventEmitter,
  Injectable,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgxImageCompressService } from "ngx-image-compress";
import dataURItoBlob from "src/app/utils/dataURItoBlob";

@Injectable()
export abstract class CrudWImageForm<T> implements OnInit {
  public imgDef =
    "https://us.123rf.com/450wm/tvectoricons/tvectoricons1811/tvectoricons181105271/112229760-add-photos-icon-trendy-flat-vector-add-photos-icon-on-white-background-from-general-collection.jpg?ver=6";
  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;

  @ViewChild("imageInput", { static: false }) public imageInput: ElementRef;
  public valueImg = "";
  public imgFile: File = undefined;

  @Output() onsave = new EventEmitter<{
    mode: string;
    value: any;
    file: File;
  }>();
  constructor(
    protected fb: FormBuilder,
    private imageCompress: NgxImageCompressService
  ) {}

  public ngOnInit() {
    this.buildForm();
  }
  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
    this.valueImg = this.imgDef;
    this.form.reset();
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;
    this.valueImg = this.imgDef;
    this.form.reset();
  }
  public setUpdate(row: T) {
    this.mode = "update";
    this.defaults = row;
    this.loadImage();
    this.fromInit(row);
  }
  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public create() {
    this.onsave.emit({
      mode: this.mode,
      value: this.form.value,
      file: this.imgFile,
    });
  }

  public update() {
    this.onsave.emit({
      mode: this.mode,
      value: this.form.value,
      file: this.imgFile,
    });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  // PARA SER SOBREESCRITOS
  protected buildForm() {
    throw new Error("Method not implemented.");
  }

  protected fromInit(row: T) {
    throw new Error("Method not implemented.");
  }

  protected loadImage() {
    throw new Error("Method not implemented.");
  }
  public getImgFile() {
    this.imageCompress.uploadFile().then(({ image, orientation }) => {
      this.imageCompress
        .compressFile(image, orientation, 50, 50) // 50% ratio, 50% quality
        .then((compressedImage) => {
          const blob = dataURItoBlob(compressedImage);
          this.valueImg = compressedImage;
          this.imgFile = new File(
            [blob],
            "Imagen" + new Date().getTime().toString(16)
          );
        });
    });
  }
  processImg(file: any) {
    const reader: FileReader = new FileReader();

    const promise: Promise<void> = new Promise((resolve) => {
      reader.onload = () => {
        this.valueImg = reader.result as string;
        this.imgFile = file;
        resolve();
      };
      reader.readAsDataURL(file);
    });
    return promise;
  }
  errorHandler(event) {
    console.debug(event);
    event.target.src = this.imgDef;
  }
  public waiting: boolean = false;
  public setWaiting(value: boolean) {
    this.waiting = value;
  }
}
